<template>
  <div class="w-full height-100">
    <el-dialog
      title=""
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      width="30%"
    >
      <template slot="title"
        ><h3 class="fsize16 Add Products text-white">
          {{ AddEdit }} Category
        </h3></template
      >
      <div>
        <el-form
          role="form"
          class=""
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
        >
          <div>
            <div v-if="editImageView">
              <p class="text-lg font-semibold text-4f4f4f mb-0">Image</p>
              <div class="relative">
                <img :src="editImageView" class="object-cover imgpre" />
                <div class="absolute top-0 right-0 bg-white rounded-full p-1">
                  <feather-icon
                    icon="XIcon"
                    svgClasses="w-3 h-3"
                    class="cursor-pointer"
                    @click="
                      () => {
                        this.editImageView = '';
                      }
                    "
                  />
                </div>
              </div>
            </div>
            <div v-else>
              <div>
                <!-- :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :file-list="fileList" -->
                <p class="text-lg font-semibold text-4f4f4f mb-0">Image</p>
                <el-upload
                  v-if="datavalue.length == 0"
                  class="upload-demo mt-1 category-uploader"
                  drag
                  action="#"
                  :before-upload="multipleimages"
                  accept="image/*"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Drop file here or <em>click to upload</em>
                  </div>
                  <!-- <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div> -->
                </el-upload>
              </div>
              <div class="mt-6">
                <div
                  v-for="(item, index) in renderedmultipleImage"
                  class="relative"
                  :key="`${item}+${index}`"
                >
                  <img :src="item" class="object-cover imgpre" />

                  <div class="absolute top-0 right-0 bg-white rounded-full p-1">
                    <feather-icon
                      icon="XIcon"
                      svgClasses="w-3 h-3"
                      class="cursor-pointer"
                      @click="
                        () => {
                          datavalue.splice(index, 1);
                          renderedmultipleImage.splice(index, 1);
                        }
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-6">
              <p class="text-lg font-semibold text-4f4f4f mb-0">
                Category Name
              </p>
              <el-form-item prop="categoryName">
                <el-input
                  placeholder="Category Name"
                  v-model="ruleForm.categoryName"
                  maxlength="50"
                  class="w-full mt-2"
                ></el-input>
              </el-form-item>
            </div>

            <!-- <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">
              Sub-category Type
            </p>
            <el-select
              multiple
              filterable
              allow-create
              default-first-option
              v-model="category"
              placeholder="Select"
              class="w-full mt-1"
            >
              <el-option
                v-for="(item, index) in EcomCategory"
                :key="`${item.categoryName}+${index}`"
                :label="item.categoryName"
                :value="item.categoryName"
              >
              </el-option>
            </el-select>
          </div>

          <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Tag</p>
            <el-select
              multiple
              filterable
              allow-create
              default-first-option
              v-model="tagName"
              placeholder="Select"
              class="w-full mt-1"
            >
              <el-option
                v-for="(item, index) in tagsDetails"
                :key="`${item.tagName}+${index}`"
                :label="item.tagName"
                :value="item.tagName"
              >
              </el-option>
            </el-select>
          </div> -->
          </div>
          <div class="flex justify-center mt-10">
            <vs-button
              @click="handleSubmit('ruleForm')"
              class="bg-primary text-white rounded-full font-semibold py-3 fsize14 px-12 sm-fsize14"
            >
              Submit
            </vs-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Add Category
          </h2>
        </div>
      </div>
    </div>

    <div class="fixed-top bg-white p-6">
      <div class="flex justify-between gap-2">
        <!-- <el-input placeholder="Enter..." class="w/-4/5" /> -->
        <el-input
          v-model="search"
          placeholder="Search here..."
          class="w-3/2"
          maxlength="50"
        />
        <div class="w-1/4 flex justify-end">
          <vs-button
            @click="handleAddEdit('Add')"
            variant="primary"
            class="border-0 font-semibold rounded-lg lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
          >
            Add Category
          </vs-button>
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-colorpd"
      >
        <el-table-column
          :index="indexmethod"
          type="index"
          label="Sr.no"
          width="80"
        ></el-table-column>
        <el-table-column prop="city" label="Category Name" min-width="200px">
          <template v-slot="{ row }">
            <P class="text-gray">{{ row.categoryName }}</P>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="city" label="Sub-Category" min-width="200px">
          <template v-slot="{ row }">
            <div class="flex gap-2 flex-wrap">
              <el-tag
                v-for="(item, index) in row.subcategories"
                :key="`${item}+${index}`"
                class="text-gray rounded-full"
                type="success"
                >{{ item.categoryName }}</el-tag
              >
            </div>
          </template>
        </el-table-column> 

        <el-table-column prop="Tag" label="Tags" min-width="200px">
          <template v-slot="{ row }">
            <div class="flex gap-2 flex-wrap">
              <el-tag
                v-for="(item, index) in row.tagId"
                :key="`${item}+${index}`"
                class="text-gray rounded-full"
                type="success"
                >{{ item.tagName }}</el-tag
              >
            </div>
          </template>
        </el-table-column>-->

        <el-table-column prop="city" label="Image" min-width="150px">
          <template v-slot="{ row }">
            <div
              v-if="
                typeof row.categoryImage != 'string' &&
                row.categoryImage &&
                row.categoryImage.length > 0
              "
            >
              <img
                :src="imageURL + '/' + row.categoryImage[0]"
                class="object-contain bg-olpink p-3 rounded-full w-12 h-12"
                alt="banh"
              />
            </div>
            <div v-else-if="typeof row.categoryImage == 'string'">
              <img
                :src="imageURL + '/' + row.categoryImage"
                class="object-contain bg-olpink p-3 rounded-full w-12 h-12"
                alt="banh"
              />
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="city" label="Actions" min-width="90px">
          <template v-slot="{ row }">
            <div class="flex gap-1 items-center">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="handleAddEdit('Edit', row)"
              />
              <!-- <feather-icon
                icon="TrashIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
              /> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="w-full flex justify-end mt-6" v-if="totalRows > 0">
        <el-pagination
          background
          layout="prev,pager,next"
          :total="totalRows"
          :page-size="perPage"
          @current-change="setPage"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
import { mapState } from "vuex";
export default {
  data() {
    return {
      drawer: false,
      direction: "rtl",
      category: [],
      tagName: [],
      // categoryName: "",
      datavalue: [],
      renderedmultipleImage: [],
      subcategoryoptions: [
        {
          value: "HTML",
          label: "HTML",
        },
        {
          value: "CSS",
          label: "CSS",
        },
        {
          value: "JavaScript",
          label: "JavaScript",
        },
      ],
      tableData: [],

      AddEdit: "Add",
      categoryId: "",
      editImageView: "",

      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,

      ruleForm: {
        categoryName: "",
      },
      rules: {
        categoryName: [
          {
            required: true,
            message: "Please Enter Category Name",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    async currentPage() {
      await this.getDetailedCategoryAll();
    },
    search: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getDetailedCategoryAll();
      }, 500),
    },
  },
  methods: {
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    handleAddEdit(name, data = {}) {
      if (name === "Add") {
        this.resetForm("ruleForm");
      } else if (name === "Edit") {
        this.categoryId = data._id ? data._id : "";
        this.ruleForm.categoryName = data.categoryName ? data.categoryName : "";
        this.editImageView =
          typeof data.categoryImage != "string" &&
          data.categoryImage &&
          data.categoryImage.length > 0
            ? this.getImage(data.categoryImage[0])
            : typeof data.categoryImage == "string"
            ? this.getImage(data.categoryImage)
            : "";
      }
      this.AddEdit = name;
      this.drawer = true;
    },
    handleSubmit(formName) {
      this.ruleForm.categoryName = this.ruleForm.categoryName.trim();

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addCategory();
        } else {
          // this.formfield();
          return false;
        }
      });
    },
    handleClose() {
      this.drawer = false;
      this.resetForm("ruleForm");
    },
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
      this.drawer = false;
      this.ruleForm.categoryName = "";
      this.datavalue = [];
      this.renderedmultipleImage = [];
      this.editImageView = "";
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },

    async getDetailedCategory() {
      await this.$store.dispatch("EcomCategory/getDetailedCategory");
    },
    async openAddCategoryForm() {
      this.resetForm("ruleForm");
      this.drawer = true;
      await this.$store.dispatch("tags/getTags");
      await this.$store.dispatch("EcomCategory/getCategory");
    },
    getImage(img) {
      return `${this.$imageURL}/${img}`;
    },
    async addCategory() {
      const payload = new FormData();
      payload.append("categoryName", this.ruleForm.categoryName);
      for (let i in this.datavalue) {
        payload.append("image", this.datavalue[i]);
      }

      if (this.AddEdit === "Edit" && this.categoryId) {
        payload.append("categoryId", this.categoryId);
      }
      // for (let i of this.category) {
      //   if (this.category.length > 1) {
      //     payload.append("category", i);
      //   } else {
      //     payload.append("category[0]", i);
      //   }
      // }
      // for (let i of this.tagName) {
      //   if (this.tagName.length > 1) {
      //     payload.append("tagName", i);
      //   } else {
      //     payload.append("tagName[0]", i);
      //   }
      // }

      let loader;
      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let createCategory;
        if (this.AddEdit === "Add") {
          createCategory = await this.$store.dispatch(
            "EcomCategory/addCategory",
            payload
          );
        } else if (this.AddEdit === "Edit") {
          createCategory = await this.$store.dispatch(
            "EcomCategory/editCategory",
            payload
          );
        }
        // console.log(createCategory);
        if (createCategory.code === 200) {
          // console.log(createCategory);
          loader.close();
          this.handleClose();
          await this.$swal({
            title: `Category ${
              this.AddEdit === "Add" ? "Created" : "Updated"
            } Successfully!`,
            type: "success",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });

          this.getDetailedCategoryAll();
          this.resetForm("ruleForm");
        }
        loader.close();
      } catch (error) {
        loader.close();
        if (error.response.data.code !== 500) {
          this.$notify.error({
            message: `${
              error.response.data.message
                ? error.response.data.message
                : "Something went wrong"
            }`,
            position: "bottom-right",
          });
        }
      }
    },
    async multipleimages(file) {
      if (this.datavalue.length < 1) {
        this.datavalue.push(file);
      } else {
        this.datavalue.shift(file);
      }
      this.newHandlemultiple(file);
    },
    async newHandlemultiple(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.renderedmultipleImage.length < 1) {
          this.$emit("load", this.renderedmultipleImage.push(e.target.result));
        } else {
          this.$emit("load", this.renderedmultipleImage.shift(e.target.result));
        }
      };

      reader.readAsDataURL(rawFile);
    },
    async getDetailedCategoryAll() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };
      let loader;

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const getAllCategory = await this.$store.dispatch(
          "EcomCategory/getDetailedCategoryAll",
          payload
        );
        // console.log(getAllCategory);
        loader.close();
        if (getAllCategory.code === 200) {
          this.totalRows = this.detailedCategoryAll.totalCount;
          this.tableData = this.detailedCategoryAll.result;
        }
      } catch (error) {
        loader.close();
      }
    },
    setPage(page) {
      this.currentPage = page;
    },
  },
  computed: {
    ...mapState("tags", ["tagsDetails"]),
    ...mapState("EcomCategory", [
      "EcomCategory",
      "detailedCategory",
      "detailedCategoryAll",
    ]),
    imageURL() {
      return process.env.VUE_APP_IMAGE_URL;
    },
  },
  async mounted() {
    // this.getDetailedCategory();
    this.getDetailedCategoryAll();
    await this.$store.dispatch("tags/getTags");
    await this.$store.dispatch("EcomCategory/getCategory");
    // console.log(this.detailedCategory);
  },
};
</script>
<style scoped>
.imgpre {
  height: 270px;
  border-radius: 8px;
  width: 100%;
}
</style>
